import Form from './FormComponent';
import List from './ListComponent';
import Selector from './SelectorComponent';
import AccountSelector from './AccountSelectorComponent';
import Bills from './bills';
import Wizard from './WizardComponent';
import SelectedIndicator from './SelectedIndicatorComponent';
import Users from './teamSharing';
import Status from './status';

const AccountsStatus = Status.AccountsStatus;

export default {
  Form,
  List,
  Selector,
  AccountSelector,
  Bills,
  SelectedIndicator,
  Wizard,
  Users,
  AccountsStatus
};



// WEBPACK FOOTER //
// ./src/components/aws/accounts/index.js